import FruitCard from "../../layouts/FruitCard";
import bg from "/cywe-assets/card/cyan.png";
import fruit from "/cywe-assets/fruit/blueberry.png";

export default function Cyan({
	setValue,
	value,
}: {
	setValue: (value: number) => void;
	value: number;
}) {
	return (
		<>
			<FruitCard
				title="The Kindness of God, leads to repentance!"
				description="Sharing, offering help whenever you can, without being asked. Knowing that a simple thoughtful gesture can make another person’s day. Wanting for others, what you want for yourself, because someone else's beauty or success doesn’t mean the absence of yours."
				bg={bg}
				fruit={fruit}
				setValue={setValue}
				value={value}
				back="/experience/5"
				next="/experience/7"
			/>
		</>
	);
}
